<template>
  <div class="pub-divider">
    <a-divider :orientation="orientation">
      {{ title }}
    </a-divider>
  </div>
</template>

<script>
export default {
  components: {},
  name: "PubDivider",
  props: {
    title: {
      type: String,
      default: "",
    },
    orientation: {
      type: String,
      default: "center",
    },
  },
};
</script>
<style lang="less">
.pub-divider {
  span {
    color: @blue;
  }
}
</style>
